"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainerWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const blikStart_svg_1 = __importDefault(require("@components/icons/blikStart.svg"));
const blikStop_svg_1 = __importDefault(require("@components/icons/blikStop.svg"));
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const selectBackground = ({ isStarted, isCheckButton, disabled, color }) => {
    if (disabled)
        return 'linear-gradient(to bottom, #dbdcdb 13.21%, #757675 81.73%)';
    if (color)
        return color;
    if (isCheckButton)
        return 'linear-gradient(to bottom, #8188FF 13.21%, #6E76FB 81.73%)';
    if (isStarted)
        return 'linear-gradient(to bottom, #FE2B2B 13.21%, #EF0F45 81.73%)';
    else
        return 'linear-gradient(to bottom, #6cff4f 13.21%, #13c21c 81.73%);';
};
const ButtonContainer = styled_components_1.default.div `
  position: relative;
  background: ${selectBackground};
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    transform 0.2s ease-in-out;
  font-size: 40px;
  font-weight: 800;
  font-family: inter;
  border: 5px solid #ffffff;
  padding: 0 20px;
  border-radius: 200px;
  overflow: hidden;
  box-shadow: inset 3px -5px 4px 1px #00000042;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    font-size: 30px;
    padding: 8px 16px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 6px 12px;
    border-radius: 40px;
    overflow: hidden;
    bottom: 0;
  }

  @media (max-width: 540px) {
    margin-top: 20px;
    font-size: 16px;
    border-radius: 32px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
    border-radius: 32px;
  }
  @media (max-width: 414px) {
    margin-top: 20px;
    border-radius: 40px;
  }

  @media (max-height: 650px) {
    ${({ isCheckButton }) => isCheckButton &&
    `
            font-size: 25px;
            padding: 4px 8px;
            border-radius: 30px;
        `}
  }

  @media (max-height: 600px) {
    font-size: 25px;
    padding: 4px 8px;
    border-radius: 30px;
  }
`;
exports.ButtonContainerWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  position: relative;
  gap: 5px;
  width: 100%;
  z-index: 1;
  @media (max-height: 450px) {
    margin-top: 10px;
  }
`;
const spin = (0, styled_components_1.keyframes) `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const LoadingSpinner = styled_components_1.default.div `
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #ffffff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;

  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
  }
`;
const BlikwDiv = styled_components_1.default.div `
  position: absolute;
  top: 5px;
  left: 13px;
  height: 60px;
  overflow: hidden;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: 400px) {
    left: 0;
    top: -10px;
    scale: 55%;
  }
`;
const Button = ({ label, onClick, isStarted, isCheckButton, isLoading, isShowShadow = true, showBlick = false, disabled = false, color, }) => {
    const windowWidth = (0, useWindowWidrh_1.default)();
    const smallViewport = windowWidth < 1200;
    return (react_1.default.createElement(ButtonContainer, { color: color, onClick: disabled ? () => { } : onClick, isStarted: isStarted, isCheckButton: isCheckButton, disabled: disabled, showShadow: isShowShadow },
        showBlick && !smallViewport ? (react_1.default.createElement(BlikwDiv, null, !isStarted ? react_1.default.createElement(blikStart_svg_1.default, null) : react_1.default.createElement(blikStop_svg_1.default, null))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        isLoading ? react_1.default.createElement(LoadingSpinner, null) : label));
};
exports.default = Button;
